(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/services/fetch-personal-results.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/services/fetch-personal-results.js');

const { jupiter } = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;

const getPath = (competitionId, teamIds, shouldFetchIndividualResults) => {
  const resultsPaths = [];
  if (shouldFetchIndividualResults) {
    resultsPaths.push(`/player/2/competitions/${competitionId}/result`);
  }
  if (teamIds) {
    teamIds.forEach((teamId) => {
      resultsPaths.push(`/player/2/competitions/${competitionId}/team/result?teamId=${teamId}`);
    });
  }
  return resultsPaths.length === 1 ?
resultsPaths.pop() :
'/multifetch?serial=true&urls=' + resultsPaths.map((path) => {
  return encodeURIComponent(path);
}).join('|');
};

const getSubscriptionPaths = (competitionId, teamIds, shouldFetchIndividualResults) => {
  const paths = [];
  if (shouldFetchIndividualResults) {
    paths.push(`/player/2/competitions/${competitionId}/result`);
  }
  if (teamIds) {
    teamIds.forEach((teamId) => {
      paths.push(`/player/2/competitions/${competitionId}/team/result?teamId=${teamId}`);
    });
  }
  return paths;
};

const startPersonalResultsSocket = (competitionId, teamIds, shouldFetchIndividualResults, onUpdate) => {
  if (svs.isServer) {
    return () => {};
  }
  if (!competitionId || typeof onUpdate !== 'function') {
    return () => {};
  }

  const socket = svs.core && svs.core.socket ? svs.core.socket : null;

  if (!socket || typeof socket.subscribe !== 'function' || typeof socket.unsubscribe !== 'function') {
    return () => {};
  }

  const subscriptions = [];
  const paths = getSubscriptionPaths(competitionId, teamIds, shouldFetchIndividualResults);

  paths.forEach((path) => {
    const ctx = {};
    try {
      socket.subscribe(path, (msg) => onUpdate(msg, path), ctx, true, true);
      subscriptions.push({ path, ctx });
    } catch (e) {
      try {
        svs.core.log.getLogger('marketplace:personal-results-socket').warn(`Failed to subscribe to ${path}`, e);
      } catch (__) {}
    }
  });

  return () => {
    subscriptions.forEach(({ path, ctx }) => {
      try {
        socket.unsubscribe(path, ctx);
      } catch (e) {
        try {
          svs.core.log.getLogger('marketplace:personal-results-socket').warn(`Failed to unsubscribe ${path}`, e);
        } catch (__) {}
      }
    });
  };
};

const fetchPersonalResults = async (competitionId, teamIds, shouldFetchIndividualResults, req) => {
  if (!competitionId) {
    return {
      responses: [undefined, undefined]
    };
  }
  const options = {
    method: 'GET',
    path: getPath(competitionId, teamIds, shouldFetchIndividualResults),
    req
  };

  return jupiter.callAsync(options);
};

if (svs.isServer) {
  module.exports = fetchPersonalResults;
} else {
  setGlobal('svs.components.marketplaceCompetition.services.services.fetchPersonalResults', fetchPersonalResults);
  setGlobal('svs.components.marketplaceCompetition.services.services.startPersonalResultsSocket', startPersonalResultsSocket);
}


 })(window);